export default __webpack_public_path__ + "static/media/editVenueImage.03f05328.png";